import React from 'react'

const EmergingTech2026 = ({ data }) => {
    return (
        data?.paragraph?.map((item, index) => {
            return (<p key={index} className="paragraph">{item?.text}<b>{item?.boldText}</b>{item?.text1}</p>)
        })
    )
}
export default EmergingTech2026
